type IconProps = React.ComponentProps<'svg'>

export function DropperIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.42)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.21936 1.04795c1.39742-1.39726 3.66312-1.39726 5.06054 0 1.39702 1.39744 1.39718 3.6632 0 5.06054l-4.46973 4.46973 0.96973 0.96973c0.29245 0.29287 0.29261 0.76777 0 1.06054-0.29276 0.29276-0.76762 0.2925-1.06054 0l-0.96973-0.96972-6.46973 6.46972c-1.3779 1.3779-3.26588 2.17355-4.74902 2.625-0.75059 0.22844-1.41954 0.37499-1.90137 0.46485-0.24113 0.04496-0.43733 0.07585-0.57422 0.0957-0.06819 0.00989-0.12251 0.01766-0.16015 0.02246-0.01848 0.00235-0.03347 0.00365-0.04395 0.00488-0.0051 0.00061-0.00959 0.00156-0.01269 0.00196-0.00134 0.00015-0.00295-0.00003-0.00391 0l-0.00098 0.00097c-0.22626 0.02514-0.45318-0.05498-0.61426-0.21582-0.16081-0.16091-0.23972-0.3862-0.21484-0.6123l0-0.00684c0.00035-0.00305 0.00133-0.00765 0.00195-0.01269 0.00125-0.01048 0.0035-0.02541 0.00586-0.04395 0.00479-0.03763 0.01158-0.09185 0.02149-0.16015 0.01984-0.13676 0.0508-0.33231 0.0957-0.57325 0.08982-0.48175 0.23642-1.15072 0.46484-1.90136 0.45142-1.48323 1.24692-3.37191 2.625-4.75l6.46973-6.46973-0.96973-0.96973c-0.29274-0.2929-0.29284-0.7677 0-1.06054 0.29285-0.29269 0.76769-0.29269 1.06055 0l0.96973 0.96972 4.46972-4.46972z m-10.93946 13.06054c-1.12191 1.12191-1.82642 2.73421-2.25 4.12598-0.16334 0.53672-0.28141 1.02853-0.36426 1.42774 0.39915-0.08283 0.89112-0.19998 1.42774-0.36329 1.39171-0.42359 3.00413-1.12913 4.12598-2.25097l6.46972-6.46973-2.93945-2.93945-6.46973 6.46972z m14.93946-12c-0.81164-0.81148-2.12782-0.81148-2.93946 0l-4.46973 4.46973 2.93946 2.93945 4.46973-4.46972c0.81139-0.81156 0.81123-2.1278 0-2.93946z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
